<template>
  <div v-if="isIdle === true && DisableConfirmation === false">
    <v-dialog v-model="isIdle" max-width="600" persistent>
      <v-card class="pt-5 px-10">
        <span class="headline">{{ messageText }}</span>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="primary" @click="onCancel">{{ ButtonText }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "Idle",
  props: {
    IdleTimeout: Number,
    WarningTimeout: Number,
    DialogText: { required: true },
    ButtonText: { required: true },
    DisableConfirmation: Boolean,
    StopCountDownOnMouseMove: Boolean,
  },
  data() {
    return {
      idleTimer: "",
      warningTimer: "",
      countDownInterval: "",
      isIdle: Boolean,
      isTimedOut: Boolean,
      secondsRemaining: Number,
      idleTimeout: 5,
      stopCountDownOnMouseMove: Boolean,
    };
  },
  computed: {
    messageText() {
      return this.DialogText.replace("##", this.secondsRemaining);
    },
  },
  created() {
    this.isIdle = false;
    this.secondsRemaining = this.WarningTimeout;
    this.idleTimeout = this.IdleTimeout || 20;
    this.startIdleTimeOut();
    document.addEventListener("click", this.onRefresh);
    document.addEventListener("mousemove", this.onRefresh);
    this.stopCountDownOnMouseMove = this.StopCountDownOnMouseMove || false;
  },
  methods: {
    onRefresh() {
      if (this.idleTimer && !this.isIdle) {
        clearTimeout(this.idleTimer);
        this.startIdleTimeOut();
      }
      if (this.warningTimer && this.stopCountDownOnMouseMove) {
        clearTimeout(this.warningTimer);
        clearInterval(this.countDownInterval);
      }
    },
    reset(newIdleTime) {
      this.idleTimeout = newIdleTime;
      document.removeEventListener("click", this.onRefresh);
      document.removeEventListener("mousemove", this.onRefresh);
      this.isIdle = false;
      if (this.idleTimer) {
        clearTimeout(this.idleTimer);
      }
      if (this.warningTimer) {
        clearTimeout(this.warningTimer);
      }
      if (this.countDownInterval) {
        clearInterval(this.countDownInterval);
      }
      this.startIdleTimeOut();

      document.addEventListener("click", this.onRefresh);
      document.addEventListener("mousemove", this.onRefresh);
    },
    setIsIdle(value) {
      this.isIdle = value;
    },
    OnWarningTimeout() {
      this.$emit("OnWarningTimeout");
    },
    OnIdleTimeout() {
      this.setIsIdle(true);
      this.startWarningTimeout();
    },
    startIdleTimeOut() {
      let idleTimeout = this.OnIdleTimeout;
      this.idleTimer = setTimeout(function() {
        idleTimeout();
      }, this.idleTimeout * 1000);
    },
    startWarningTimeout() {
      let warningTimeout = this.OnWarningTimeout;
      if (this.DisableConfirmation === false) {
        this.startWarningCountDown();
        this.warningTimer = setTimeout(function() {
          warningTimeout();
        }, this.WarningTimeout * 1000);
      } else {
        warningTimeout();
      }
    },
    startWarningCountDown() {
      this.secondsRemaining = this.WarningTimeout;
      let decrementSecondsRemaining = this.decrementSecondsRemaining;
      this.countDownInterval = setInterval(function() {
        decrementSecondsRemaining();
      }, 1000);
    },
    decrementSecondsRemaining() {
      --this.secondsRemaining;
    },
    onCancel() {
      this.isIdle = false;
      if (this.idleTimer) {
        clearTimeout(this.idleTimer);
      }
      if (this.warningTimer) {
        clearTimeout(this.warningTimer);
      }
      if (this.countDownInterval) {
        clearInterval(this.countDownInterval);
      }
      this.startIdleTimeOut();
    },
  },
};
</script>

<style scoped>
.v-btn {
  height: 50px !important;
  color: white !important;
  width: 150px;
}
</style>
